import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateDepartmentForm } from "../../forms"

export const CreateDepartment: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreateDepartmentForm />
		</VStack>
	)
}
